/**
 * State used in rendering DataGridHeader
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
